import * as React from 'react'
import { FormEvent, ReactElement, useEffect, useState } from "react";
import { DefaultButton, DetailsListLayoutMode, Selection, IComboBox, IComboBoxOption, IObjectWithKey, SelectionMode, CheckboxVisibility, FontIcon, NeutralColors, IDetailsListStyles, DetailsList } from "@fluentui/react";
import { useNavigate } from "react-router-dom";
import { mergeStyles, mergeStyleSets } from '@fluentui/react/lib/Styling';
import { IButtonGroup, IColumn, IPaginacionComponent } from '../../interfaces/base/ITable';
import { ButtonGroupTable } from '../../components/button/ButtonGroupTable';
import { SpinnerTable } from '../spinner/SpinnerTable';
import { PaginationComponent } from '../Pagination/PaginationComponent';
import { gridStyles, useStyles } from "./TableComponentStyles";
import { IUbicacionDTO } from '../../interfaces/ubicacion/IUbicacion';

interface ITableComponent {
  isSearch?: boolean;
  column?: IColumn[] | any;
  data: any[];
  height?: string;
  placeholderSearch?: string;
  isLoading?: boolean;
  searchValue?: string;
  comboOptions?: IComboBoxOption[];
  onSelectCombo?: (event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined) => void;
  leftButtons?: IButtonGroup[];
  defaultSelectedOptions?: IComboBoxOption[];
  rightButton?: IButtonGroup[];
  rightText?: string | ReactElement;
  onChangeSearch?: (
    event?: React.ChangeEvent<HTMLInputElement> | undefined, newValue?: string | undefined
  ) => void;
  paginacion?: IPaginacionComponent;
  customTableWidth?: boolean;
  onEnterTextBox?: () => void;
  labelString?: string,
  btnString?: string
  navigate?: string
  setOpen?: (boolean) => void
  header?: boolean,
  compact?: boolean
  tableWidth?: string
  selection?: SelectionMode
  setItemSeleccionadoValue?: React.Dispatch<any>
  visualizar?: () => JSX.Element
}
const iconClass = mergeStyles({
  fontSize: 40,
  height: 50,
  width: 50,
  padding: '25px 0 0 0',
});

const classNames = mergeStyleSets({
  contentIcon: [{ color: NeutralColors.gray70 }, iconClass],
});


export const TableComponent = (props: ITableComponent) => {
  const styles = useStyles()
  const navigate = useNavigate();
  const [itemSeleccionado, setItemSeleccionado] = useState<IObjectWithKey>();
  const _selection = new Selection({ onSelectionChanged: () => { setItemSeleccionado(_selection.getSelection()[0]) } })

  function onRenderDetailsHeader(headerProps: any, defaultRender: any) {
    return defaultRender({
      ...headerProps,
      styles: {
        root: {
          paddingTop: '0px',
          textAlign: ''
        },
      },
    })
  }

  function _renderItemColumn(item?: IUbicacionDTO, index?: number, column?: IColumn) {
    if (item == undefined || index === undefined || column === undefined) {
      return null;
    }
    
    const fieldContent = item[column.fieldName as keyof IUbicacionDTO] as string;

    switch (column.key) {
      case 'estado':
        return (
          <div className={mergeStyles({ width: '100%', display: 'flex', alignItems: 'center', gap: '.3rem' })}>
            <div
              className={mergeStyles({
                backgroundColor: fieldContent == "Activo" ? "green" : "red",
                height: '.5rem',
                width: '.5rem',
                color: 'white',
                borderRadius: '50%',
              })}
            > </div>
            <div>{fieldContent}</div>
          </div>
        );

      default:
        return <span>{fieldContent}</span>;
    }
  }

  useEffect(() => {
    if (itemSeleccionado && props.setItemSeleccionadoValue != undefined) {
      props.setItemSeleccionadoValue(itemSeleccionado)
    }
  }, [itemSeleccionado]);
  const renderEmptyState = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "gray",
        textAlign: "center",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "1rem" }}>
        <FontIcon aria-label="Refresh" iconName="Refresh" className={classNames.contentIcon} />
        <h4 style={{ margin: "0" }}>No se encontraron registros</h4>
      </div>
      {props.btnString && (
        <>
          <div>¿Desea añadir {props.labelString}?</div>
          <br />
          <DefaultButton
            text={props.btnString}
            onClick={() => {
              if (props.setOpen) {
                props.setOpen(true);
              } else if (props.navigate) {
                navigate(props.navigate);
              }
            }}
            style={{ marginTop: "10px" }}
          />
        </>
      )}
    </div>
  )
  return (
    <div
      className={styles.page}
    >
      <div className={styles.head}>
        <ButtonGroupTable
          isSearch={props.isSearch}
          leftButtons={props.leftButtons}
          value={props.searchValue}
          defaultSelectedOptions={props.defaultSelectedOptions}
          comboOptions={props.comboOptions}
          rightText={props.rightText}
          onSelectCombo={props.onSelectCombo}
          rightButton={props.rightButton}
          placeholder={props.placeholderSearch}
          onChangeSearch={props.onChangeSearch}
          onEnterTextBox={props.onEnterTextBox}
        />
      </div>
      <div
        className={styles.main}
      >
        {!props.isLoading ? (
          props.data?.length === 0 ? (
            renderEmptyState()
          ) : (
            <div style={{ display: 'flex' }}>
              <div style={{ width: props.tableWidth != null ? props.tableWidth : "100%" }}>
                <DetailsList
                  items={props.data}
                  isHeaderVisible={props.header == null ? true : props.header}
                  compact={true}
                  // compact={props.compact == null ? false : props.compact}
                  columns={props.column}
                  setKey="set"
                  onRenderDetailsHeader={onRenderDetailsHeader}
                  onRenderItemColumn={_renderItemColumn}
                  layoutMode={DetailsListLayoutMode.justified}
                  selectionMode={props.selection == null ? SelectionMode.none : props.selection}
                  checkboxVisibility={CheckboxVisibility.hidden}
                  selection={_selection}
                  styles={gridStyles}
                />
              </div>
              {props.visualizar && (<div>
                {props.visualizar()}
              </div>)}
            </div>
          )
        ) : (
          <SpinnerTable />
        )}
      </div>
      {props.paginacion?.isVisible && (
        <div className={styles.footer}>
          <PaginationComponent
            actualPage={props.paginacion.actualPage}
            onChangeTake={props.paginacion.onChangeTake}
            onChangeSkip={props.paginacion.onChangeSkip}
            totalPagesPagination={props.paginacion.totalPagesPagination}
            skipPagination={props.paginacion.skipPagination}
            takePagination={props.paginacion.takePagination}
            isLoading={props.isLoading}
            cantidad={props.data?.length}
            total={props.paginacion.total} isVisible={true} />
        </div>
      )}
    </div>

  )
}
